export const ASK_PROMPTS = [
  '📊 Review my pitch deck',
  '💰 Help me raise funding',
  '🎯 Find my early customers',
  '💡 Get a second opinion',
  '💬 Ask a question',
]
